<script>
    import { tick, onDestroy } from "svelte";
    import Chart from "chart.js/auto";
    import Gradient from "../../../services/gradient.js";
    import { truncateString } from "../../../js/utils.js";
    import { format } from "svelte-i18n";
    import { goto } from "@roxi/routify";

    let { data = [], field = "value", filter = {} } = $props();

    let redirect = $goto;
    const apacheEncode = (val) => val ? encodeURIComponent(val) : "";

    let canvas = $state();
    let chart;

    let dataCopy = $derived.by(() => {
        let copy = JSON.parse(JSON.stringify(data || []));

        if (copy.length >= 10) {
            let otherResults = copy.splice(9);
            let result = otherResults.reduce((accumulator, currentObject) => {
                return accumulator + (currentObject.count || 0);
            }, 0);

            copy.push({
                count: result,
                value: $format("others"),
                name: $format("others"),
                kind: $format("others"),
            });
        }
        return copy;
    });

    let gradientArray = $derived.by(() => {
        let colors = new Gradient()
            .setColorGradient("#343a40", "#3c8dbc")
            .setMidpoint(dataCopy.length <= 5 ? 5 : dataCopy.length)
            .getColors();

        return colors.map((color) => color + "AE");
    });

    $effect(() => {
        const currentData = dataCopy;
        const currentGradient = gradientArray;

        if (!canvas) return;

        let isDestroyed = false;

        async function initChart() {
            if (chart) {
                chart.destroy();
                chart = null;
            }

            await tick();
            if (isDestroyed || !canvas) return;

            let context = canvas.getContext("2d");

            let chartData = {
                labels: [],
                datasets: {
                    backgroundColor: currentGradient,
                    data: [],
                },
            };

            for (const obj of currentData) {
                if (obj.value === "" || !obj.value) obj.value = "N/A";
                obj.value = truncateString(obj.value, 47);
                chartData.labels.push(obj.label ? obj.label : obj[field]);
                chartData.datasets.data.push(obj.count);
            }

            chart = new Chart(context, {
                type: "doughnut",
                data: {
                    labels: chartData.labels,
                    datasets: [chartData.datasets],
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    borderWidth: 1,
                    weight: 20,
                    plugins: {
                        legend: {
                            position: "right",
                            labels: {
                                font: {
                                    fontFamily: "Montserrat",
                                    size: 14,
                                },
                            },
                        },
                        title: {
                            display: false,
                        },
                    },
                    animation: {
                        animateScale: true,
                        animateRotate: true,
                    },
                    onHover: (event, activeElements) => {
                        if (canvas) {
                            canvas.style.cursor = activeElements.length
                                ? "pointer"
                                : "default";
                        }
                    },
                    onClick: (event, activeElements) => {
                        if (!activeElements.length || !chart) return;

                        const elementIndex = activeElements[0].index;
                        const label = chart.data.labels[elementIndex];

                        if (label === $format("others")) return;

                        redirect("/property/asset/[kind]", {
                            kind: apacheEncode(label),
                            ...filter,
                        });
                    },
                },
            });
        }

        initChart();

        return () => {
            isDestroyed = true;
            if (chart) {
                chart.destroy();
                chart = null;
            }
        };
    });

    onDestroy(() => {
        if (chart) {
            chart.destroy();
            chart = null;
        }
    });
</script>

<canvas
    bind:this={canvas}
    id="chart-vuls-by-severity"
    class:chart-has-no-data={!data || data.length <= 0}
></canvas>
